import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { setTimeout$, Utility } from 'src/app/core/common';
import { MetadataType } from 'src/app/common';

@Component({
  selector: 'app-refine',
  templateUrl: './refine.component.html',
  styleUrls: ['./refine.component.scss']
})
export class RefineComponent implements OnInit {
  Object = Object;
  MetadataType = MetadataType;
  constructor(private spinner: SpinnerService, private metadataService: MetadataService) { }

  async ngOnInit() {
    await this.load();
  }

  list: any[];
  async load() {
    this.spinner.show('action');
    this.list = await this.metadataService.search({ Types: [MetadataType.WrongSkill] });
    this.spinner.hide('action');
  }

  rules: any[];
  read(raw: string) {
    this.spinner.show('action');
    setTimeout$(() => {
      this.rules = Utility.flat((<any[]>JSON.parse(raw))
        .map(_ => Utility.flat(_.edits.map(e => e.from.map(f => { return f == e.to ? null : { Header: f, Variations: [e.to] }; })))))
        .filter(_ => _ && !this.list.find(l => _.Header == l.Header));
      this.spinner.hide('action');
    });
  }

  async save() {
    this.spinner.show('action');
    await this.metadataService.saveBulk(MetadataType.WrongSkill, this.rules);
    this.load();
    this.spinner.hide('action');
  }
}
